import React from 'react';
import { MapPin, FileText, Users, ThumbsUp } from 'lucide-react';
const values = [{
  icon: <MapPin className="w-10 h-10 text-brand" data-id="element-145" />,
  title: 'Local and Proud',
  description: 'We live and work right here in Denton. Your neighbors are our neighbors.'
}, {
  icon: <FileText className="w-10 h-10 text-brand" data-id="element-146" />,
  title: 'No-Hassle Estimates',
  description: 'Free quotes, clear pricing, no surprises when the invoice arrives.'
}, {
  icon: <Users className="w-10 h-10 text-brand" data-id="element-147" />,
  title: 'Craftsmen, Not Crews',
  description: 'Every project is done with care and attention, not rushed off a truck.'
}, {
  icon: <ThumbsUp className="w-10 h-10 text-brand" data-id="element-148" />,
  title: '100% Satisfaction',
  description: "We don't leave until you love it. That's the Cool Lawns promise."
}];
export function WhyUs() {
  return <section id="about" className="py-20 md:py-28 bg-[#F7F7F7]" data-id="element-149">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-150">
        <div className="mb-16" data-id="element-151">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4 inline-block relative" data-id="element-152">
            Why Denton Chooses Us
            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-brand rounded-full" data-id="element-153"></span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-154">
          {values.map((value, index) => <div key={index} className="flex flex-col items-start" data-id="element-155">
              <div className="bg-white w-20 h-20 rounded-2xl shadow-sm flex items-center justify-center mb-6" data-id="element-156">
                {value.icon}
              </div>
              <h3 className="font-heading font-bold text-xl text-gray-900 mb-3" data-id="element-157">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-158">
                {value.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}